// components
import { PageSectionInner } from '@/components/PageSection';

// styles
import {
  MissionWrapper,
  MissionTitle,
  MissionLabel,
  MissionText,
} from './Mission.styles';

export function Mission({ content }) {
  return (
    <MissionWrapper>
      <PageSectionInner>
        <MissionTitle>
          <MissionLabel>{content.label}</MissionLabel>
          <MissionText>{content.text}</MissionText>
        </MissionTitle>
      </PageSectionInner>
    </MissionWrapper>
  );
}
